<h1 matDialogTitle>{{ "ADD_CREDIT_CARD.TITLE" | translate }}</h1>
<app-credit-card-form #newPaymentCreditCardForm></app-credit-card-form>
<div *ngIf="error" class="error">
    {{ error }}
</div>
<div mat-dialog-actions align="end">
    <button
        mat-raised-button
        class="mat-accent mr-16"
        color="primary"
        [disabled]="!newPaymentCreditCardForm.isValid() || _loading"
        [mat-dialog-close]="newPaymentCreditCardForm.creditCardData"
    >
        {{ "ADD_CREDIT_CARD.ADD_BUTTON" | translate }}
    </button>
    <button mat-button mat-dialog-close>
        {{ "ADD_CREDIT_CARD.CANCEL_BUTTON" | translate }}
    </button>
</div>
